/**
 * CRM共通ユーティリティ
 *
 * CRMロール型、ロール階層、権限チェック関数、UI用のラベル・オプションを
 * 一箇所に集約し、フロントエンド全体で一貫して利用する。
 */

/**
 * CRMロール型
 */
export type CrmRole = "viewer" | "editor" | "admin";

/**
 * CRMロール階層マップ（数値が大きいほど上位）
 */
export const CRM_ROLE_HIERARCHY: Record<CrmRole, number> = {
  viewer: 1,
  editor: 2,
  admin: 3,
};

/**
 * 指定ロール以上の権限を持っているか判定する
 * @param {string | null} userRole ユーザーの現在のCRMロール
 * @param {string} requiredRole 必要な最低CRMロール
 * @return {boolean} requiredRole 以上であれば true
 */
export function hasCrmRoleOrAbove(
  userRole: CrmRole | null,
  requiredRole: CrmRole,
): boolean {
  if (!userRole) return false;
  const userLevel = CRM_ROLE_HIERARCHY[userRole] ?? 0;
  const requiredLevel = CRM_ROLE_HIERARCHY[requiredRole] ?? 0;
  return userLevel >= requiredLevel;
}

/**
 * CRMロールの日本語ラベルレコード
 */
export const CRM_ROLE_LABELS: Record<CrmRole, string> = {
  viewer: "閲覧者",
  editor: "編集者",
  admin: "管理者",
};

/**
 * CRMロール選択肢（セレクトボックス用）
 */
export const CRM_ROLE_OPTIONS: ReadonlyArray<{
  value: CrmRole;
  label: string;
}> = [
  { value: "viewer", label: "閲覧者" },
  { value: "editor", label: "編集者" },
  { value: "admin", label: "管理者" },
];
